import src from '../assets/teetogreen-dark.png';
import { imageLogo } from './imageLogo';

export const TeeToGreenDarkLogo = imageLogo({
  src,
  width: 245,
  height: 240,
  alt: 'Tee to Green',
});
